import { Button } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';

export const deleteRowCommand = ({ editor, range }) =>
  range ? editor.chain().focus().deleteRange(range).deleteRow().run() : editor.chain().focus().deleteRow().run();

const DeleteRow = ({ editor, showLabel = false, isExtension = false }) => {
  return (
    <Button
      className={`editor-toolbar-btn-container !bg-transparent`}
      icon={<CloseOutlined className="text-gray-800 text-xs" />}
      onClick={isExtension ? () => {} : () => deleteRowCommand({ editor })}
      size="small"
      type="text"
    >
      {showLabel && (
        <div className="editor-toolbar-btn-label">
          <FormattedMessage id="TABLE_DELETE_ROW" defaultMessage="Delete row" />
        </div>
      )}
    </Button>
  );
};

export default DeleteRow;
